// Vuetify 2 is EOL: keep its title formatter out of innerHTML (CVE-2025-8082).
export function renderDatePickerTitle() {
    const h = this.$createElement;
    const text = String(this.date || "\u00a0").split(/<br\s*\/?>/gi);
    const children = text.flatMap((part, index) => index ? [h("br"), part] : [part]);
    return h("transition", { props: { name: this.computedTransition } }, [
        h("div", { key: this.value }, children),
    ]);
}

export function protectDatePickerTitle(component) {
    component.options.methods.genTitleText = renderDatePickerTitle;
    // Vue rebuilds constructor options from extendOptions after a global mixin.
    component.extendOptions.methods.genTitleText = renderDatePickerTitle;
}
